module.exports = __webpack_public_path__ + "static/media/previous_section.b28d7864.svg";